<template>
  <div>
    <div class="spell">
      <div v-if="ishavedbuy">
        <div v-if="scrabble.is_leader">
          <h4 v-if="this.countdown!=-1">
            您发起的拼团还有：{{time}}结束
        </h4>
          <div class="corps_online">
            <h3>还差 <span>{{scrabble.num - 1 - scrabble.leaderlist.length}}</span> 位好友即可拼团成功，快去邀请吧！</h3>
            <ul class="leader_ul clearfix">
              <li>
                <img :src="scrabble.leaderimg" alt="" />
                <span>团长</span>
              </li>
              <li v-for="(item,index) in scrabble.leaderlist" :key="index">
                <img :src="item.headimgurl" alt="" />
              </li>
              <li v-for="(item,index) in (scrabble.num - 1 - scrabble.leaderlist.length)" :key="index">
                <img src="@a/spell_add.png" alt="" class="add" />
              </li>
              <li v-if="scrabble.num>5" class="nv">
                <b>...</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else>
        <h2 v-if="scrabble.countdown!=-1">拼团倒计时：{{time}} </h2>
        <h1 v-if="scrabble.foreman">—— 发起拼团，成为团长! ——</h1>
        <div class="corps_online" v-if="scrabble.corps_online && scrabble.scrabble_list.length>0">
          <h3>有 <span>{{scrabble.scrabble_list.length}}</span>人 正在拼团</h3>
          <div class="spell_div">
            <ul class="spell_ul clearfix">
              <li v-for="(item,index) in scrabble.scrabble_list" :key="index" v-if="index<4">
                <img :src="item.headimgurl" alt="" />
              </li>
              <li v-if="scrabble.scrabble_list.length>4" class="spe">
                <b>...</b>
              </li>
            </ul>
            <div class="button" @click="list_show=true">
              去参团 ￥ {{scrabble.price}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="list_show">
      <div class="list">
        <h2>正在拼团<img src="@a/app_close.png" alt="" @click="list_show=false"/></h2>
        <ul>
          <li v-for="(item,index) in scrabble.scrabble_list" :key="index" class="clearfix">
            <div class="img">
              <img :src="item.headimgurl" alt="" />
              <span>团长</span>
            </div>
            <div class="time">
              <h3>差{{item.surplus}}人成团</h3>
              <h4>{{item.time}}后结束</h4>
            </div>
            <router-link :to="'/course_spell?scrabble_type=join&scrabble_id=' + item.id">
              去参团
            </router-link>
          </li>
        </ul>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
      return {
        countdown: 0,
        time: '',
        list_show: false,
        clearInters: [],
      }
    },
    props: {
      scrabble: {
        type: Object,
        default: false
      },
      ishavedbuy: {
        default: null
      }
    },
    methods: {
      timeTostring1(obj) {
        if (obj.countdown > 0) {
          let sin = setInterval(() => {
            var secondTime = parseInt(obj.countdown); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            var dayTime = 0; // 天
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
                if (hourTime > 24) {
                  //获取天，获取小时除以24，得到整数天
                  dayTime = parseInt(hourTime / 24);
                  //获取天后取佘的小时，获取小时除以24取佘的小时
                  hourTime = parseInt(hourTime % 24);
                }
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime) + " ";

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ": " + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ": " + result;
            }

            obj.time = result;
            obj.countdown -= 1;
          }, 1000);
          this.clearInters.push(sin);
        } else {
          clearInterval(sin)
        }
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.countdown > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.countdown); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            var dayTime = 0; // 天
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
                if (hourTime > 24) {
                  //获取天，获取小时除以24，得到整数天
                  dayTime = parseInt(hourTime / 24);
                  //获取天后取佘的小时，获取小时除以24取佘的小时
                  hourTime = parseInt(hourTime % 24);
                }
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime) + " 秒";

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + " 分 " + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + " 时 " + result;
            }
            if (dayTime > 0 && !this.scrabble.is_leader) {
              result = ((dayTime < 10) ? "0" : "") + parseInt(dayTime) + " 天 " + result;
            }

            this.time = result;
            this.countdown -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }
      },
      pullData() {
        if (!this.scrabble.is_leader) {
          this.countdown = this.scrabble.countdown;
        } else {
          this.countdown = this.scrabble.leadercountdown;
        }
        if (this.scrabble.scrabble_list.length) {
          for (let [index, arg] of this.scrabble.scrabble_list.entries()) {
            arg['time'] = '00:00:00';
            this.timeTostring1(this.scrabble.scrabble_list[index]);
          };
        }
        this.timeTostring();
      },
    },
    created() {
      this.pullData();
    },
    destroyed() {
      clearInterval(this.sin);
      for (let args of this.clearInters) {
        clearInterval(args)
      }
    }
}
</script>
<style lang="scss" scoped>
.spell {
  width: 690px;
  margin: 0 auto;
  background: rgba(240, 240, 240, 1);
  border-radius: 16px;
  margin-top: 40px;
  margin-bottom: 30px;
  text-align: center;
  padding: 40px 0;
  h2 {
    font-size: 26px;
    color: #333;
  }
  h1 {
    margin-top: 30px;
    font-size: 38px;
    color: #F57F17;
  }
  h4 {
    font-size: 24px;
    color: #666;
  }
  .corps_online {
    text-align: center;
    margin-top: 16px;
    h3 {
      font-size: 28px;
      color: #333;
      font-weight: bold;
      span {
        color: #F57F17
      }
    }
    ul.leader_ul {
      margin: 0 auto;
      margin-top: 30px;
      text-align: center;
      display: inline-block;
      li {
        width: 70px;
        height: 70px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
        margin-left: 50px;
        float: left;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .add {
          width: 28px;
          height: 28px;
          border-radius: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        span {
          display: inline-block;
          width: 54px;
          height: 26px;
          background: linear-gradient(90deg, rgba(235, 80, 50, 1), rgba(245, 127, 23, 1));
          border-radius: 13px;
          line-height: 26px;
          color: #fff;
          font-size: 18px;
          position: absolute;
          bottom: 0;
          left: 8px;
        }
        b {
          font-size: 55px;
          color: #ccc;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .nv {
        background: none;
      }
    }
    .spell_div {
      text-align: center;
      margin-top: 28px;
      ul.spell_ul {
        display: inline-block;
        vertical-align: middle;
        li {
          width: 70px;
          height: 70px;
          margin-left: -20px;
          float: left;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          b {
            font-size: 55px;
            color: #ccc;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .spe {
          margin-left: 0;
        }
      }
      .button {
        display: inline-block;
        width: 200px;
        height: 54px;
        background: linear-gradient(90deg, rgba(235, 80, 50, 1), rgba(245, 127, 23, 1));
        border-radius: 27px;
        margin-left: 40px;
        font-size: 28px;
        line-height: 54px;
        text-align: center;
        color: #fff;
      }
    }
  }
}

.list {
  width: 600px;
  height: 815px;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  overflow-y: scroll;
  padding-top: 92px;
  position: relative;
  h2 {
    font-size: 36px;
    color: #333;
    line-height: 92px;
    border-bottom: 2px solid #ccc;
    position: relative;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 1;
    img {
      position: absolute;
      top: 36px;
      right: 30px;
      width: 24px;
      height: 24px;
    }
  }
  ul li {
    margin-top: 40px;
    padding: 0 30px;
    .img {
      width: 100px;
      height: 100px;
      float: left;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      span {
        display: inline-block;
        width: 66px;
        height: 30px;
        background: linear-gradient(90deg, rgba(235, 80, 50, 1), rgba(245, 127, 23, 1));
        border-radius: 15px;
        line-height: 30px;
        color: #fff;
        font-size: 20px;
        position: absolute;
        bottom: 0;
        left: 17px;
        text-align: center;
      }
    }
    .time {
      margin-left: 22px;
      float: left;
      margin-top: 10px;
      h3 {
        font-size: 26px;
        color: #333;
      }
      h4 {
        margin-top: 10px;
        font-size: 24px;
        color: #999;
      }
    }
    a {
      width: 134px;
      height: 54px;
      background: rgba(235, 80, 50, 1);
      border-radius: 27px;
      float: right;
      line-height: 54px;
      color: #fff;
      font-size: 26px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
</style>
